import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AccessContext = createContext({});

export const AccessProvider = ({ userId, children }) => {
  const [accessMap, setAccessMap] = useState({});
  const [loading, setLoading] = useState(true);

  // 🔹 Get role_id from localStorage
  const roleId = Number(localStorage.getItem("role_id"));

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        if (!userId) {
          setAccessMap({});
          setLoading(false);
          return;
        }

        const resp = await axios.get(
          `${process.env.REACT_APP_API_URL}/coursebuilder-access`,
          {
            params: { user_id: userId },
          }
        );

        const tools = resp?.data?.data ?? [];

        if (!mounted) return;

        const map = {};

        tools.forEach((t) => {
          const id = Number(t.tool_id); // ✔ FIXED, dynamic

          if (!Number.isNaN(id)) {
            map[id] = {
              view: t.view === 1 || t.view === true,
              edit: t.edit === 1 || t.edit === true,
            };
          } else {
            console.warn("Invalid tool_id:", t);
          }
        });

        setAccessMap(map);
      } catch (err) {
        console.warn("Failed to load access list", err);
        setAccessMap({});
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, [userId]);

  const hasView = (toolId) => accessMap[Number(toolId)]?.view === true;
  const hasEdit = (toolId) => accessMap[Number(toolId)]?.edit === true;

    // ✅ Special rule:
  // Tool ID = 3
  // Role ID = 1 or 3
  // Allow Save & Edit UI even if edit = false
  const canSaveEdit = (toolId) => {
    const id = Number(toolId);

    if (id === 3 && (roleId === 1 || roleId === 3)) {
      return true;
    }

    return hasEdit(id);
  };

  return (
    <AccessContext.Provider
      value={{
        accessMap,
        hasView,
        hasEdit,      // 🔴 use this for DELETE
        canSaveEdit,  // ✅ use this for SAVE & EDIT
        loading,
      }}
    >
      {children}
    </AccessContext.Provider>
  );
};

export const useAccess = () => useContext(AccessContext);
